import { Box, FormLabel, Stack, TextField } from '@mui/material';
import React from 'react';
import { Control, Controller } from 'react-hook-form';

import InputRichText from '../../../components/InputRichText';
import { NoteFormData } from '../types/notes.types';

interface NoteFormProps {
    control: Control<NoteFormData>;
}

export const NoteForm: React.FC<NoteFormProps> = ({ control }) => {
    return (
        <Box>
            <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2} mb={2}>
                <FormLabel sx={{ fontSize: 16, color: theme => theme.palette.text.primary }}>Visibilite</FormLabel>
                <Controller
                    control={control}
                    name="visibility"
                    render={({ field }) => (
                        <Box
                            sx={{
                                display: 'flex',
                                border: '1px solid #F2F1FF',
                                borderRadius: '8px',
                                overflow: 'hidden',
                            }}>
                            {(['public', 'private'] as const).map((item) => (
                                <Box
                                    key={item}
                                    onClick={() => field.onChange(item)}
                                    sx={{
                                        flex: 1,
                                        padding: '8px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: theme => field.value === item ? (theme.palette.mode === 'dark' ? 'rgba(242, 241, 255, 0.1)' : '#F7F6FF') : 'transparent',
                                        border: theme => `0.5px solid ${theme.palette.border.main}`,
                                        fontSize: '13px',
                                        fontWeight: field.value === item ? 700 : 500,
                                        lineHeight: '20px',
                                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                                        transition: 'all 0.2s',
                                        '&:hover': {
                                            opacity: 0.8,
                                        },
                                    }}>
                                    {item === 'public' ? 'Public' : 'Prive'}
                                </Box>
                            ))}
                        </Box>
                    )}
                />
            </Stack>

            <Controller
                control={control}
                name="title"
                rules={{ required: true }}
                render={({ field }) => (
                    <TextField
                        {...field}
                        fullWidth
                        label="Titre"
                        placeholder="Titre du commentaire"
                        required
                        sx={{
                            mb: 2,
                            '& .MuiInputLabel-root': {
                                color: theme => theme.palette.text.secondary,
                            },
                        }}
                    />
                )}
            />

            <InputRichText
                control={control}
                name="note"
                label="Commentaire"
                placeholder="Ecrivez votre commentaire ici"
                required
            />
        </Box>
    );
};
